import React, { useEffect, useState } from "react";

import {
  ApiError,
  registerLawyer,
  sendLawyerRegistrationCode,
  type LawyerRegistrationResult,
} from "../api/client";
import { RegistrationForm, type RegistrationValues } from "./RegistrationForm";
import { RegistrationResult } from "./RegistrationResult";
import "./registration.css";

const EMPTY_VALUES: RegistrationValues = {
  mobile: "",
  code: "",
  name: "",
  acceptedTerms: false,
};

function errorMessage(error: unknown): string {
  if (!(error instanceof ApiError)) return "服务暂时不可用，请稍后重试";
  if (error.code === "SMS_RATE_LIMITED") return "验证码发送过于频繁，请稍后再试";
  if (error.code === "SMS_CODE_INVALID") return "验证码错误，请重新输入";
  if (error.code === "SMS_CODE_EXPIRED") return "验证码已过期，请重新获取";
  if (error.code === "MOBILE_CONFLICT") return "该手机号已关联其他平台账号";
  return error.message;
}

export function LawyerRegistrationApp() {
  const invitationCode = new URLSearchParams(window.location.search).get("invite");
  const [values, setValues] = useState(EMPTY_VALUES);
  const [countdown, setCountdown] = useState(0);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState<LawyerRegistrationResult | null>(null);

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = window.setTimeout(() => setCountdown((value) => Math.max(0, value - 1)), 1000);
    return () => window.clearTimeout(timer);
  }, [countdown]);

  const sendCode = async () => {
    if (!/^1\d{10}$/.test(values.mobile)) {
      setError("请输入正确的手机号");
      return;
    }
    setBusy(true);
    setError("");
    try {
      await sendLawyerRegistrationCode(values.mobile);
      setCountdown(60);
    } catch (caught) {
      setError(errorMessage(caught));
    } finally {
      setBusy(false);
    }
  };

  const submit = async () => {
    if (!/^1\d{10}$/.test(values.mobile) || !/^\d{6}$/.test(values.code) || values.name.trim().length < 2) {
      setError("请完整填写手机号、验证码和律师本人姓名");
      return;
    }
    if (!values.acceptedTerms) {
      setError("请先同意用户协议和隐私授权");
      return;
    }
    setBusy(true);
    setError("");
    try {
      setResult(await registerLawyer({
        mobile: values.mobile,
        code: values.code,
        name: values.name.trim(),
        accepted_terms: true,
        invitation_code: invitationCode,
      }));
    } catch (caught) {
      setError(errorMessage(caught));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="lawyer-registration-page">
      <div className="lawyer-registration-brand">中承信合数据服务平台</div>
      {result ? (
        <RegistrationResult result={result} />
      ) : (
        <RegistrationForm
          values={values}
          countdown={countdown}
          busy={busy}
          onChange={setValues}
          onSendCode={() => void sendCode()}
          onSubmit={() => void submit()}
        />
      )}
      {error && <div className="lawyer-registration-error" role="alert">{error}</div>}
    </main>
  );
}
